/**
 * Registration page with RegisterForm component
 */

import { useNavigate } from 'react-router-dom';
import { RegisterForm } from '@/components/auth/RegisterForm';

export function RegisterPage() {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <div className="flex min-h-dvh items-center justify-center bg-gradient-to-br from-purple-50 to-blue-50 p-4 dark:from-gray-900 dark:to-gray-800">
      <main className="w-full max-w-md">
        <div className="mb-8 text-center">
          <h1 className="mb-2 text-4xl font-bold text-primary">Muenstergram</h1>
          <p className="text-muted-foreground">Join and start sharing today</p>
        </div>

        <RegisterForm onLoginClick={handleLoginClick} />
      </main>
    </div>
  );
}
